exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-view {\n  background-color: #fff;\n  box-sizing: border-box;\n  padding: 2em 3em;\n}\n.user-view h1 {\n  margin: 0;\n  font-size: 1.5em;\n}\n.user-view .meta {\n  list-style-type: none;\n  padding: 0;\n}\n.user-view .label {\n  display: inline-block;\n  min-width: 4em;\n}\n.user-view .about {\n  margin: 1em 0;\n}\n.user-view .links a {\n  text-decoration: underline;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/views/UserView.vue?vue&type=style&index=0&id=4d74474a&lang=stylus&
// module id = 540
// module chunks = 8